import { useCallback, useSyncExternalStore } from 'react';
import { isAudioMuted, setAudioMuted, subscribeAudioMuted } from '../lib/soundEffects';

/**
 * Reactive access to the player's global "mute game audio" preference.
 *
 * The preference lives in lib/audio/player.ts (persisted to localStorage and
 * applied to Howler + the iOS audio session), so every surface that reads it
 * stays in lockstep. Returns the current value plus a stable toggle.
 */
export function useAudioMuted(): { muted: boolean; toggle: () => void; setMuted: (v: boolean) => void } {
  const muted = useSyncExternalStore(subscribeAudioMuted, isAudioMuted, isAudioMuted);
  const setMuted = useCallback((v: boolean) => setAudioMuted(v), []);
  const toggle = useCallback(() => setAudioMuted(!isAudioMuted()), []);
  return { muted, toggle, setMuted };
}
